import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router';
import { UserModel } from '../../api/authentication/authentication.types';
import { userCanAccessComponent } from '../../helpers/authentication.helper';
import { AppState } from '../../store/store.types';

interface ConditionalRouteProps extends RouteProps {
  user: UserModel | null;
  acceptedRoles: string[];
}
class ConditionalRoute extends PureComponent<ConditionalRouteProps> {

  render() {
    if (this.props.user && userCanAccessComponent(this.props.user, this.props.acceptedRoles)) {
      return <Route {...this.props} />;
    }

    return <Route {...this.props} render={() => <Redirect to="/invalidpermissions" />} />;
  }

}

const mapStateToProps = (state: AppState) => ({
  user: state.authentication.user
});

export default connect(mapStateToProps)(ConditionalRoute);
